// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"171":"feb5566d","247":"de1ee255","787":"e63eb7b0"}[chunkId] + ".chunk.js";
};